module.exports = __webpack_public_path__ + "img/image15511.e5972c22.jpg";